module.exports = __webpack_public_path__ + "static/media/signage-industrial-img21.6a66da8f.jpg";